// settings for image changer
const imageChanger = () => {
  const totalImageCount = 50;
  const changeInterval = 2000;
  const changeCountPerTrigger = 2;
  // @ts-ignore
  const themeUrl = window.themeData?.themeUrl || '';

  const imageUrls = Array.from(
    {
      length: totalImageCount,
    },
    (_, i) => {
      return `${themeUrl}/public/img/page-slides/${i + 1}.jpg`;
    },
  );

  const leftContainer = document.getElementById('left-container');
  const rightContainer = document.getElementById('right-container');

  function getUsedUrls() {
    const activeImages = Array.from(
      document.querySelectorAll('.img-slot img.active'),
    );
    //@ts-ignore
    return activeImages.map((img) => img.dataset.src);
  }

  // @ts-ignore
  function getUniqueRandomUrl(excludeUrls) {
    let candidates = imageUrls.filter((url) => !excludeUrls.includes(url));

    if (candidates.length === 0) {
      candidates = imageUrls;
    }
    return candidates[Math.floor(Math.random() * candidates.length)];
  }

  function createSlot() {
    const slot = document.createElement('div');
    slot.className = 'layout__slideshow-slot img-slot';

    const img1 = document.createElement('img');
    const img2 = document.createElement('img');

    const usedUrls = getUsedUrls();
    const initialSrc = getUniqueRandomUrl(usedUrls);
    img1.src = initialSrc;
    img1.dataset.src = initialSrc;
    img1.className = 'active';

    const fallback = function () {
      //@ts-ignore
      this.src =
        'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
      //@ts-ignore
      this.onerror = null;
    };
    img1.onerror = fallback;
    img2.onerror = fallback;

    slot.appendChild(img1);
    slot.appendChild(img2);
    return slot;
  }

  function updateLayout() {
    [leftContainer, rightContainer].forEach((container) => {
      if (!container || container.clientWidth === 0) {
        //@ts-ignore
        container.innerHTML = '';
        return;
      }

      const containerHeight = container.clientHeight;

      const aspectRatio = window.innerWidth >= 1500 ? 3 / 2 : 1;
      const slotHeight = container.clientWidth / aspectRatio;

      let maxSlots = Math.ceil(containerHeight / slotHeight);
      maxSlots = Math.max(0, maxSlots);

      const currentSlots = container.querySelectorAll('.img-slot');
      if (currentSlots.length < maxSlots) {
        for (let i = 0; i < maxSlots - currentSlots.length; i++) {
          container.appendChild(createSlot());
        }
      } else if (currentSlots.length > maxSlots) {
        for (let i = 0; i < currentSlots.length - maxSlots; i++) {
          //@ts-ignore
          container.lastElementChild.remove();
        }
      }
    });
  }

  // @ts-ignore
  function changeImageForSlot(slot, recentlySelectedUrls) {
    const images = slot.querySelectorAll('img');
    const activeImg = slot.querySelector('img.active') || images[0];
    const nextImg = activeImg === images[0] ? images[1] : images[0];

    // @ts-ignore
    const activeUrls = Array.from(
      document.querySelectorAll('.img-slot img.active'),
    )
      //@ts-ignore
      .map((img) => img.dataset.src)
      .filter((url) => url !== activeImg.dataset.src);

    const excludeUrls = [
      ...activeUrls,
      ...recentlySelectedUrls,
      activeImg.dataset.src,
    ];

    const newSrc = getUniqueRandomUrl(excludeUrls);

    nextImg.dataset.src = newSrc;
    nextImg.src = newSrc;

    nextImg.onload = () => {
      activeImg.classList.remove('active');
      nextImg.classList.add('active');
    };
    nextImg.onerror = function () {
      this.src =
        'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    };

    return newSrc;
  }

  setInterval(() => {
    const allSlots = Array.from(document.querySelectorAll('.img-slot'));
    if (allSlots.length === 0) return;

    const targets = allSlots
      .sort(() => 0.5 - Math.random())
      .slice(0, changeCountPerTrigger);
    //@ts-ignore
    const newSelectedUrls = [];

    targets.forEach((slot) => {
      //@ts-ignore
      const newSrc = changeImageForSlot(slot, newSelectedUrls);
      newSelectedUrls.push(newSrc);
    });
  }, changeInterval);

  let resizeTimer: any;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateLayout, 200);
  });

  updateLayout();
};

export default imageChanger;
